import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  widgets: {
    readyToMove: {
      data: null,
      subtitle: null,
    },
    labourTurnover: {
      data: null,
      subtitle: null,
    },
    engagementScoreLine: {
      data: null,
      subtitle: null,
    },
    riskOfLeavingBar: {
      data: null,
      subtitle: null,
    },
    engagementScoreDoughnut: {
      data: null,
      subtitle: null,
    },
    agreedLAndDCompletion: {
      data: null,
      subtitle: null,
    },
    leaversInFirst100Days: {
      data: null,
      subtitle: null,
    },
    averageLengthOfService: {
      data: null,
      subtitle: null,
    },
    employeeNetPromotorScore: { data: null, subtitle: null, subtitle: null },
    journeyResponses: {
      data: null,
      subtitle: null,
    },
  },
}

export default function employeeEngagementReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.EmployeeEngagement) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.EmployeeEngagement, "")

  switch (actionType) {
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
        widgets: {
          readyToMove: {
            data: null,
            subtitle: null,
          },
          engagementScoreLine: {
            data: null,
            subtitle: null,
          },
          riskOfLeavingBar: {
            data: null,
            subtitle: null,
          },
          engagementScoreDoughnut: {
            data: null,
            subtitle: null,
          },
          agreedLAndDCompletion: {
            data: null,
            subtitle: null,
          },
          leaversInFirst100Days: {
            data: null,
            subtitle: null,
          },
          averageLengthOfService: {
            data: null,
            subtitle: null,
          },
          employeeNetPromotorScore: {
            data: null,
            subtitle: null,
          },
          labourTurnover: {
            data: null,
            subtitle: null,
          },
          journeyResponses: {
            data: null,
            subtitle: null,
          },
        },
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        widgets: {
          ...state.widgets,
          readyToMove: action.payload.data.readyToMove,
          labourTurnover: action.payload.data.labourTurnover,
          engagementScoreLine: action.payload.data.engagementScoreLine,
          riskOfLeavingBar: action.payload.data.riskOfLeaving,
          engagementScoreDoughnut: action.payload.data.engagementScoreDoughnut,
          agreedLAndDCompletion: action.payload.data.agreedLearningAndDevelopment,
          leaversInFirst100Days: action.payload.data.leaversInFirst100Days,
          averageLengthOfService: action.payload.data.averageLengthOfService,
          employeeNetPromotorScore: action.payload.data.customNpsScore,
          journeyResponses: action.payload.data.journeys,
        },
      }

    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        widgets: {
          ...state.widgets,
          readyToMove: { data: null, subtitle: null },
          engagementScoreLine: { data: null, subtitle: null },
          riskOfLeavingBar: { data: null, subtitle: null },
          labourTurnover: { data: null, subtitle: null },
          engagementScoreDoughnut: { data: null, subtitle: null },
          agreedLAndDCompletion: { data: null, subtitle: null },
          leaversInFirst100Days: { data: null, subtitle: null },
          employeeNetPromotorScore: { data: null, subtitle: null },
          averageLengthOfService: { data: null, subtitle: null },
          journeyResponses: { data: null, subtitle: null },
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/employeeEngagementReducer.js